
// Env.go
export enum AppEnvironment {
	Production = 'PRODUCTION',
	Development = 'DEVELOPMENT',
	UAT = 'UAT',
}
